export interface SuportAreaTranslations {
	title: string;
	questionTitle: string;
	questionDescription: string;
	openTicket: string;
	close: string;
}

export const SUPORT_AREA_PT_BR: SuportAreaTranslations = {
	title: "Central de ajuda",
	questionTitle: "Precisa de ajuda?",
	questionDescription:
		"Abra um novo chamado ou acompanhe os que já estão em andamento com nosso time.",
	openTicket: "Falar com atendente",
	close: "Fechar",
};
